import { getBuildInfo } from './getBuildInfo'

let isInserted = false
export const insertBuildInfoComment = () => {
  if (isInserted) return

  const buildInfo = getBuildInfo()
  if (!buildInfo) return null

  const {
    appBuild,
    appBuildDate,
    appName,
    platformBuild,
    platformBuildDate,
    toolbarBuild,
    toolbarBuildDate,
  } = buildInfo

  document.body?.appendChild(
    document.createComment(`
    ${appName},    #${appBuild}, ${appBuildDate}
    toolbar,   #${toolbarBuild}, ${toolbarBuildDate}
    platform,  #${platformBuild}, ${platformBuildDate}
    `),
  )
  isInserted = true
}
